import type { TooltipProps } from '@mui/material/Tooltip';
import { useState } from 'react';
import { Tooltip } from '@mui/material';

const TooltipCopied = (props: Omit<TooltipProps, 'title'>): React.ReactElement => {
  const { children, ...rest } = props;
  const defaultTitle = 'Click to Copy';
  const [title, setTitle] = useState(defaultTitle);
  const [open, setOpen] = useState(false as any);

  const handleClose = () => {
    if (open !== 'force') {
      setOpen(false);
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const onClick = () => {
    setOpen('force');
    setTitle('Copied!!');
    setTimeout(() => {
      setOpen(false);
      setTimeout(() => {
        setTitle(defaultTitle);
      }, 100);
    }, 1000);
  };
  return (
    <Tooltip
      {...rest}
      open={Boolean(open)}
      onClose={handleClose}
      onOpen={handleOpen}
      title={title}
      onClick={onClick}
      arrow
    >
      {children}
    </Tooltip>
  );
};

export default TooltipCopied;
